import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-confimation-page-platform',
  templateUrl: './confimation-page-platform.component.html',
  styleUrls: ['./confimation-page-platform.component.scss']
})
export class ConfimationPagePlatformComponent {
  public externalId = '';
  public hidePageConfirmationPlatform = false;

  constructor(private activatedRouter: ActivatedRoute,) {
    this.activatedRouter.queryParams.subscribe((params) => {
      this.externalId = params['external_id'];
    });
  }

  ngOnInit(): void {
    if (this.externalId) {
      this.hidePageConfirmationPlatform = true;
    }
  }
}
